// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalEligibilityRequestSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return MedicalV1MedicalEligibilityRequestSearchDefaultResponseData.attributeTypeMap;
    }
}
MedicalV1MedicalEligibilityRequestSearchDefaultResponseData.discriminator = undefined;
MedicalV1MedicalEligibilityRequestSearchDefaultResponseData.additionalProperties = false;
MedicalV1MedicalEligibilityRequestSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "requests",
        "baseName": "requests",
        "type": ""
    },
];
//# sourceMappingURL=medicalV1MedicalEligibilityRequestSearchDefaultResponseData.js.map